import { SearchUrlParamBuilder } from '@/core/utils'
import axios from 'axios'

const URL_PATH = 'api/itemAta/saldo'

class TransferenciaApiClient {
	async buscarEstoquePorOrgaos(idItem, paginacao) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/itens`,
			filters: { idItemAta: idItem },
			pagingAndSorting: paginacao,
		}).build()
		return await axios.get(URL)
	}

	async buscarOrgaosCessionarios(filtro) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/orgaosCessionarios`,
			filters: filtro,
		}).build()

		return await axios.get(URL)
	}

	async transferirSaldo(dados) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `api/itemAta/${dados.idItemAta}/saldo/transferir`,
		}).build()
		return await axios.put(URL, dados)
	}

	async buscarHistoricoTransferencia(idItemAta, paginacao) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/historico`,
			filters: { idItemAta: idItemAta },
			pagingAndSorting: paginacao,
		}).build()
		return await axios.get(URL)
	}
}

export default new TransferenciaApiClient()
